const initialState = {
  filters: {
    date: {
      fechaStartFinal: null,
      fechaEndFinal: null
    },
    tags: [],
    personId: '',
    type: '',
    subtype: '',
    datos: null,
    loading: false,
    status: null
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/tasks_manager/initialState.js